import { LoanApplicationService } from "../../services/LoanApplication";
import GetAuthContext from "../../shared/context/AuthContext";
import { CustomLoaderFunctionArgs } from "../../shared/router/RouteLoader";

export async function sanctionPlLoader({
  params,
  pageName,
  getToken,
}: CustomLoaderFunctionArgs) {
  const [sanctionDetails, sanctionConditions, sanctionConditionFile] =
    await Promise.all([
      LoanApplicationService.getPLSanctions({
        loanApplicationID: params?.loanID as string,
        pageName: pageName!,
        token: getToken(),
        type: "Sanctions",
        sourceEntityID: params?.sourceEntityID as string,
      }),
      LoanApplicationService.getPLSanctionConditions({
        loanApplicationID: params?.loanID as string,
        pageName: pageName!,
        token: getToken(),
        type: "Sanctions",
        sourceEntityID: params?.sourceEntityID as string,
      }),
      LoanApplicationService.getSanctionConditionFile({
        loanApplicationID: params?.loanID as string,
        pageName: pageName!,
        token: getToken(),
        sourceEntityID: params?.sourceEntityID as string,
      }),
    ]);
  return { sanctionDetails, sanctionConditions, sanctionConditionFile };
}
